import { AxiosResponse } from 'axios'
import axios from 'lib/axios'

export interface ResponseTypes {
  status: string
  message: string
  data: any
}

// small change to trigger build
export const closeAllEvaluations360 = async (evaluatorUserTestId: number) => {
  const PATH = `${process.env.REACT_APP_MAIN_API}/test360/close-all-evaluations`

  const body = {
    evaluator_user_test_id: evaluatorUserTestId,
  }

  try {
    const response: AxiosResponse<ResponseTypes> = await axios.post(PATH, body)
    return response.data
  } catch (error) {
    throw new Error('Error closing evaluation')
  }
}
